import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import './LogIn.css';
import { setIsLoggedIn } from '../../store';

function LogIn() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    // 돌아갈 경로 설정, 기본값은 홈
    const from = location.state?.from || '/';

    return (
        <div className="common-padding login-container">
            <h2>로그인</h2>
            <form onSubmit={(e) => {
                e.preventDefault(); // 폼 제출 기본 동작 방지
                dispatch(setIsLoggedIn()); // 로그인 상태 설정
                navigate(from, { replace: true }); // 로그인 후 이전 페이지로 이동
            }}>
                <div className="input-group">
                    <input
                        type="text"
                        id="username"
                        placeholder="아이디"
                    />
                </div>
                <div className="input-group">
                    <input
                        type="password"
                        id="password"
                        placeholder="비밀번호"
                    />
                </div>
                <button type="submit" className="login-button"> 로그인 </button>
            </form>
        </div>
    );
}

export default LogIn;
